import { type GiftCardBalance, type GiftCardOffer } from './GiftCard.types'
import {
  BookSize,
  GiftCardStatus,
  GiftCardType,
  ProductIds,
  type TILE_SIZES,
} from '@mixtiles/web-backend-shared'
import { type CheckoutSummaryProduct } from '../../components/Pricing/types/checkout.types'
import {
  PRODUCT_TYPES,
  VOUCHER_PRODUCT_TYPES,
} from '../../services/ProductTypeState'
import intersection from 'lodash/intersection'

export function isGiftCardOrder(productType: PRODUCT_TYPES): boolean {
  return VOUCHER_PRODUCT_TYPES.includes(productType)
}

export function formatGiftCardOfferToProducts(
  offer: GiftCardOffer,
  productType: PRODUCT_TYPES
): CheckoutSummaryProduct[] {
  const isBusiness = productType === PRODUCT_TYPES.BUSINESS
  if (offer.type === GiftCardType.VALUE) {
    return [
      {
        id: ProductIds.GIFT_CARD_VALUE,
        value: offer.value,
        quantity: isBusiness ? offer.recipientsCount : 1,
      },
    ]
  } else if (offer.type === GiftCardType.TILES) {
    return [
      {
        id: ProductIds.GIFT_CARD_TILES,
        value: offer.value,
        quantity: isBusiness ? offer.recipientsCount : 1,
      },
    ]
  } else if (offer.type === GiftCardType.BOOKS) {
    return [
      {
        id: ProductIds.GIFT_CARD_BOOKS,
        value: offer.value, // Number of books
        quantity: isBusiness ? offer.recipientsCount : 1,
        pricingProduct: {
          tileSize: offer.bookSize as unknown as TILE_SIZES,
        },
      },
    ]
  } else {
    throw new Error(`Unknown gift card type`)
  }
}

export function isValidGiftCard({ balance, status }: GiftCardBalance) {
  return (
    balance &&
    balance > 0 &&
    [GiftCardStatus.ACTIVE, GiftCardStatus.SCHEDULED].includes(status)
  )
}

export function isBookCreditsCoupon(coupon: {
  metadata: {
    tileSizesList: string[]
  }
}) {
  return (
    intersection(coupon.metadata?.tileSizesList, Object.values(BookSize))
      .length > 0
  )
}
